import { animate, style, transition, trigger } from '@angular/animations';

export const opacityInOut = trigger('opacityInOut', [
  transition(':enter', [ style({ opacity: 0 }), animate(100) ]),
  transition(':leave', [ animate(200, style({ opacity: 0 })) ])
]);
